export default "__VITE_ASSET__CXRb_5zK__"